import { HeatmapSourceProviderFactory } from './HeatmapArtifactFactory'
import { StillFrameSourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/StillFrameFactory'
import { SourceHolder, SourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/SourceProviderFactory'
import { LTESourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/LTEArtifactFactory'
import { SingleFrameSourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/SingleFrameArtifactFactory'

export const sourceProviderFactories: Record<string, SourceProviderFactory<SourceHolder<object>>> = {
  stillFrame: new StillFrameSourceProviderFactory(),
  'artifact.heatmap': new HeatmapSourceProviderFactory(),
  'artifact.longTimeExposure': new LTESourceProviderFactory(),
  'artifact.archivedStillFrame': new SingleFrameSourceProviderFactory(),
}
